import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const phoneNumber = '+972528943335';
  const message = 'שלום! אני מעוניין/ת לקבל מידע נוסף על שירותי צביעת הרהיטים שלכם';

  useEffect(() => {
    // Show button after a short delay
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip for first-time visitors
      const hasSeenTooltip = localStorage.getItem('whatsapp-tooltip-seen');
      if (!hasSeenTooltip) {
        setShowTooltip(true);
        // Auto-hide tooltip after 5 seconds
        setTimeout(() => {
          setShowTooltip(false);
          localStorage.setItem('whatsapp-tooltip-seen', 'true');
        }, 5000);
      }
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber.replace(/\+/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setShowTooltip(false);
  };

  return (
    <>
      {/* WhatsApp Floating Button */}
      <div
        className={`fixed bottom-6 left-6 z-50 transition-all duration-500 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
      >
        {/* Tooltip */}
        {showTooltip && (
          <div className="absolute bottom-full left-0 mb-4 w-64 bg-white rounded-2xl shadow-2xl p-4 animate-bounce">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600"
              aria-label="סגור הודעה"
            >
              <X className="w-4 h-4" />
            </button>
            <p className="text-gray-800 text-sm font-semibold mb-2">
              צריכים עזרה?
            </p>
            <p className="text-gray-600 text-xs">
              שלחו לנו הודעה בוואטסאפ ונחזור אליכם בהקדם!
            </p>
            <div className="absolute bottom-0 left-8 transform translate-y-1/2 rotate-45 w-3 h-3 bg-white"></div>
          </div>
        )}

        {/* Main Button */}
        <button
          onClick={handleWhatsAppClick}
          className="group relative bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 hover:shadow-green-500/50"
          aria-label="שלח הודעה בוואטסאפ"
        >
          {/* Icon */}
          <MessageCircle className="w-8 h-8 relative z-10" />

          {/* Notification Badge */}
          <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-6 h-6 flex items-center justify-center animate-bounce">
            1
          </div>
        </button>

        {/* Text Label (shows on hover on desktop) */}
        <div className="hidden md:block absolute right-full top-1/2 -translate-y-1/2 mr-4 bg-green-500 text-white px-4 py-2 rounded-lg shadow-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <span className="font-semibold">שלחו לנו הודעה!</span>
          <div className="absolute left-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-green-500"></div>
        </div>
      </div>

      {/* Phone Number Link (Alternative for mobile) */}
      <a
        href={`tel:${phoneNumber}`}
        className={`fixed bottom-24 left-6 z-50 md:hidden bg-amber-500 hover:bg-amber-600 text-white rounded-full p-4 shadow-2xl transition-all duration-500 hover:scale-110 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10 pointer-events-none'
        }`}
        aria-label="התקשר אלינו"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      </a>
    </>
  );
};

export default WhatsAppButton;
